import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events'
import { DEFAULT_ENTITIES } from 'hooks/analytics_events/constants'

export const trackEditorOpen = ({
  track,
  destination,
  source,
  kind,
  poolingType,
  id,
  type,
  metRelationship
}) => {
  const properties = {
    destination,
    location: source,
    event_type_kind: kind,
    event_type_type: type
  }

  if (poolingType) {
    properties.event_type_pooling_type = poolingType
  }

  if (metRelationship) {
    properties.managed_et_relationship = metRelationship
  }

  // Initialize entities with defaults
  const entities = [...DEFAULT_ENTITIES]

  // Add event_type_id to dependencies and 'event_type' to entities when we have an id
  const dependencies = {}
  if (id) {
    dependencies.event_type_id = id
    entities.push('event_type')
  }

  track({
    name: TRACKING_EVENT_NAMES.EVENT_TYPE_EDITOR_OPEN,
    dependencies,
    entities,
    properties
  })
}
